/* eslint-disable no-undef */
// @ts-nocheck

//928288071099925 sandbox
// 1272085639484790 huft
let pixelId;
let pixelList;
// 8607957054 huft
// 57629278414 sandbox
let shopId;
let externalId;
let fbc;

export const callFacebook = (eventName, data) => {
  if (eventName == 'trackEvents') {
    shopId = +data.data.merchantInfo.storeId;
    externalId = data.data.externalId;
    (fbc = data?.data?.fbc || data?.data?.kpmclid), (pixelList = data.data.merchantInfo.fbpixel?.split(','));
    pixelList?.forEach((el) => {
      pixelId = +el;
      if (shopId && pixelId && data.firePageView && !eventName.includes('Custom'))
        initPageViewEvt(data.stepName, data.data);
    });
    facebookAnalyticsEvent(data);
  }
};

// function randomString() {
//   return Math.floor(Math.random() * parseInt('9'.repeat(19)));
// }

function alphaNumeric(len) {
  var p = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return [...Array(len)].reduce((a) => a + p[~~(Math.random() * p.length)], '');
}

function initPageViewEvt(stepName, data) {
  const { random, userInfo } = data;
  const alphaNumericRandom = alphaNumeric(28);
  const uri = encodeURIComponent(location.origin);
  let imgSrc = 'https://www.facebook.com/tr/';

  // CHECKOUT-7053
  if (!window.location.origin.includes('ventra')) {
    imgSrc = `${imgSrc}?ev=PageView&eid=Gokwik ${random}&ud[em]=${userInfo.email}&ud[fn]=${userInfo.firstname}&ud[ln]=${userInfo.lastname}&ud[ct]=${userInfo.city}&ud[ph]=${userInfo.phone}&ud[st]=${userInfo.state}&ud[zp]=${userInfo.pincode}&ud[country]=${userInfo.country}&id=${pixelId}&external_id=${userInfo.request_id}&dl=${uri}/${shopId}/checkouts/${alphaNumericRandom}/thank_you`;
  }

  var img = document.createElement('img');
  img.src = imgSrc;
  img.width = '1px';
  img.height = '1px';
  img.style.display = 'none';
  document.querySelector('body').appendChild(img);
}

const facebookAnalyticsEvent = (data) => {
  const eventPayload = {
    content_type: data.data.contentType,
    value: (+data.data.totalValue).toFixed(2),
    content_ids: data.data.contentId,
    contents: data.data.contents,
    num_items: data.data.numitems,
    currency: data.data.currency,
    external_id: externalId,
  };

  if (data.stepName.includes('Custom')) {
    const eventName = data.stepName.replace('Custom_', '');
    if (data.kwikOptimizerPixelIds?.length) {
      data.kwikOptimizerPixelIds.forEach((pixelId) => {
        fbq(
          'trackSingleCustom',
          pixelId,
          eventName,
          {
            ...eventPayload,
            fbc: data?.data?.fbc || data?.data?.kpmclid,
          },
          { eventID: `Gokwik ${data.data.random}` }
        );
      });
    } else {
      fbq(
        'trackCustom',
        eventName,
        {
          ...eventPayload,
          fbc: data?.data?.fbc,
        },
        { eventID: `Gokwik ${data.data.random}` }
      );
    }
  } else {
    // This are basically Standard Events
    const eventName = data.stepName === 'Initiate Checkout' ? 'InitiateCheckout' : data.stepName;
    fbq(
      'track',
      eventName,
      {
        ...eventPayload,
        fbc: data?.data?.fbc || data?.data?.kpmclid,
      },
      { eventID: `Gokwik ${data.data.random}` }
    );
  }
};
